import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import LeistungenPage from '@/pages/leistungen/page';
import AnfragePage from '@/pages/anfrage/page';
import KontaktPage from '@/pages/kontakt/page';
import ImpressumPage from '@/pages/impressum/page';
import DatenschutzPage from '@/pages/datenschutz/page';
import UeberUnsPage from '@/pages/ueber-uns/page';
import StellenangebotePage from '@/pages/stellenangebote/page';
import ReferenzenPage from '@/pages/referenzen/page';
import DankePage from '@/pages/danke/page';
import ShopPage from '@/pages/shop/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/ueber-uns', element: <UeberUnsPage /> },
  { path: '/leistungen', element: <LeistungenPage /> },
  { path: '/anfrage', element: <AnfragePage /> },
  { path: '/kontakt', element: <KontaktPage /> },
  { path: '/impressum', element: <ImpressumPage /> },
  { path: '/datenschutz', element: <DatenschutzPage /> },
  { path: '/stellenangebote', element: <StellenangebotePage /> },
  { path: '/referenzen', element: <ReferenzenPage /> },
  { path: '/danke', element: <DankePage /> },
  { path: '/shop', element: <ShopPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
